import { render, staticRenderFns } from "./cgwReviewList.vue?vue&type=template&id=b7222a48&scoped=true&"
import script from "./cgwReviewList.vue?vue&type=script&lang=js&"
export * from "./cgwReviewList.vue?vue&type=script&lang=js&"
import style0 from "./cgwReviewList.vue?vue&type=style&index=0&id=b7222a48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7222a48",
  null
  
)

export default component.exports